export var DH = {
    CHAT_MESSAGE_TEXT: 'CHAT_MESSAGE_TEXT',
    VIDEO_CONTAINER: 'VIDEO_CONTAINER',
    LOCAL_VIDEO: 'LOCAL_VIDEO',
    REMOTE_VIDEO: 'REMOTE_VIDEO',
    CONTENT_SHARE: 'CONTENT_SHARE',
    VIDEO_OFF: 'VIDEO_OFF',
    PREV_PAGE: 'PREV_PAGE',
    NEXT_PAGE: 'NEXT_PAGE',
};
//# sourceMappingURL=data-hooks.js.map